import { useMemo, useState } from "react"; // Added useState
import { Button } from "antd";
import * as XLSX from 'xlsx';
import MinimizeIcon from "../../assets/icons/minimize.svg";
import chartSeg from "../../assets/icons/pivot-report.svg";
import MaximiseIcon from "../../assets/icons/Maximize-1.svg";
import { useNavigate } from "react-router-dom";
import { showErrorToast, showInfoToast, showSuccessToast } from "../../utilities/toastUtils";
import QueryBuilderTable from "../CustomTable/queryBuilderRable";


const defaultConfig = {
  showCreateReport: true,
  isExpanded: false
};

const BottomTableBar = ({ setPage, setRowPerPage, page, perPage, queryID, connection_Id, getQueryTableResult, loading, onExcelExport = null, config = {} }: any) => {
  const updatedConfig = { ...defaultConfig, ...config }

  const navigate = useNavigate()

  const rows = useMemo(() => {
    return getQueryTableResult?.result?.map((row: any, index: number) => {
      const transformedRow: any = {};

      Object.entries(row).forEach(([key, value]) => {
        const splitKey = key.includes('#') ? key.split('#')[1] : key;
        transformedRow[splitKey] = value !== null ? value : "null"; // Null values as string
      });

      transformedRow.uniqueId = row?.doc_count_id ?? row?.id ?? `row-${index}`;

      return transformedRow;
    }) || [];
  }, [getQueryTableResult, queryID]);

  const getRowId = (row: any) => row.uniqueId;

  const [isExpanded, setIsExpanded] = useState(updatedConfig.isExpanded)
  const [isExportLoading, setIsExportLoading] = useState(false)

  const tableColumns = useMemo(() => {
    if (!rows.length) {
      return [];
    }
    const firstRow = rows[0];
    const columns: any[] = [];
    Object.keys(firstRow).forEach((key) => {
      if (key == 'doc_count_id') return;
      columns.push({
        field: key,
        headerName: key.charAt(0).toUpperCase() + key.slice(1),
        width: 200,
      })
    });
    return columns.filter((column) => column.field !== "uniqueId");
  }, [rows]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage + 1);
  };

  const handleChangePagination = (event: any) => {
    setRowPerPage(event.target.value);
    setPage(1);
  };

  const changeSortModel = (newSortModel: any) => {
    //handle change sort model
  };

  const handleOnResize = () => {
    setIsExpanded(!isExpanded)
  }

  const handleDownloadExcel = async () => {
    setIsExportLoading(true);
    try {
      if (typeof onExcelExport === 'function') {
        await onExcelExport(getQueryTableResult?.result); // assume it returns a Promise
      } else {
        const worksheet = XLSX.utils.json_to_sheet(getQueryTableResult?.result);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Query Results");
        XLSX.writeFile(workbook, "query_results.xlsx");
        showSuccessToast("Query result data has been exported successfully!");
      }
    } catch (error) {
      showErrorToast(`Failed to export query result data: ${error}`);
    } finally {
      setIsExportLoading(false);
    }
  };

  return (
    <div
      className="BottomTable-container"
      style={{
        background: "#FFFFFF",
        position: "absolute",
        bottom: 0,
        left: "5px",
        right: "10px",
        zIndex: 5,
        borderRadius: "20px",
        transition: "height 0.3s ease",
      }}
    >
      <div className="bottom-wrap">
        <div className="d-flex align-items-center justify-content-end p-2 gap-2 wrap-table-contain">
          {getQueryTableResult?.total > 0 && <div><p className="mb-0" style={{fontSize: '12px'}}>No.of Columns {tableColumns.length} and Rows {getQueryTableResult?.total}</p></div>}
          <Button className='btn-querytab' onClick={handleDownloadExcel} loading={isExportLoading} icon={<img src={chartSeg} alt="chart icon" />}>Download as CSV</Button>
          <Button
            icon={<img src={isExpanded ? MinimizeIcon : MaximiseIcon}
              alt={isExpanded ? 'minimize-icon' : 'maximize-icon'} />}
            onClick={handleOnResize}
            style={{ backgroundColor: 'transparent', border: 'none' }}
          />
        </div>
        <QueryBuilderTable
          rows={rows}
          getRowId={getRowId}
          columns={tableColumns}
          selectionModel={[]}
          changeSortModel={changeSortModel}
          perPage={perPage}
          handleChangePagination={handleChangePagination}
          count={getQueryTableResult?.total}
          page={page}
          handleChangePage={handleChangePage}
          handleOnRowClick={() => { }}
          tableHeader={"Query Result"}
          loading={loading}
          isExpanded={isExpanded}
          message={getQueryTableResult?.message}
        />
      </div>

    </div>
  );
};

export default BottomTableBar;